import React, {forwardRef, useLayoutEffect, useRef, useState} from 'react';
import classNames from 'classnames';
import mStyles from './image.module.sass';
import Skeleton from '../skeleton/skeleton';

const ImageComponent = ({
    src,
    className,
    skeletonProps,
    alt,
    kind = 'rectangular', // rectangular | circular
    ...rest
}, ref) => {
    const imagePreload = useRef(new Image());
    const [isImageLoaded, setIsImageLoaded] = useState(false);

    const imgClass = classNames('image', className);

    useLayoutEffect(() => {
        imagePreload.current.onload = function() {
            setIsImageLoaded(true);
        };
        imagePreload.current.onerror = function() {
            setIsImageLoaded(false);
            console.log('error on load image from: ', src);
        };
        imagePreload.current.src = src;
    }, [src]);

    if (!isImageLoaded) {
        return {
            rectangular: <Skeleton.Rectangular {...skeletonProps} />,
            circular: <Skeleton.Circular {...skeletonProps} />,
        }[kind];
    };

    return <img alt={alt} {...rest} className={imgClass} src={src} />;
};

export default forwardRef(ImageComponent);
